import urls from './urls'
import authToken from './authToken';
import { DataManager, WebApiAdaptor } from "@syncfusion/ej2-data";
import apis from './network'
import logger from './logger'
import rules from './permissions'
import checkUIPermissions from './UIPermissions'

class CustomWebApiAdaptor extends WebApiAdaptor {
    beforeSend(dm, xhttp, p3) {

        const originalFail = p3.onFailure;

        p3.onFailure = function (err) {
            if (err.status === 401) {
                const token = authToken.get();
                if (token) {
                    logger.log("trying token refresh...", err);
                    apis.unprotectedApi.put(
                        "/auth",
                        {
                            Token: token
                        }
                    ).then((r) => r.data).then((resp) => {                   
                        authToken.set(resp.token || resp.Token);
                        rules.getPermissions(resp.token || resp.Token);
                        checkUIPermissions();
                        logger.log("refreshed");
                    }).catch((err) => {
                        logger.log("refresh token failed", err)
                        //navigate to login - some questions asked
                        apis.navigateToLogin(window.location.pathname);
                    });
                } else {
                    logger.log("No token to refresh...", err)
                    apis.navigateToLogin(window.location.pathname);
                }
            }

            if (originalFail && typeof (originalFail) === "function") {
                try {
                    originalFail(err);
                } catch (e) {
                    logger.log("original error handler failed", err);
                    logger.log("new error", e);
                }
                
            }
        }

        super.beforeSend(dm, xhttp, p3);
    }
}

const SyncHelper = {
    getDataManager: (relativePath, queryString) => {
        return new DataManager({
            url: `${urls.apiBaseUrl}${relativePath}${(queryString ? ('?' + queryString) : '')}`,
            adaptor: new CustomWebApiAdaptor,
            crossDomain: true,
            headers: [{ Authorization: `Bearer ${authToken.get()}`}]
        });
    }
};

export default SyncHelper;